import { Module } from "vuex";

export const flowData: Module<any, any> = {
  state: {
    currentpopup: {},
    queryflowdata: {},
    checkOpen: false,
    currentPage: {},
    checkLink: "",
  },
  getters: {
    currentpopup: (state) => state.currentpopup,
    queryflowdata: (state) => state.query,
  },
  mutations: {
    setcurrentPage(state, data) {
      state.currentPage = data;
    },
    setcurrentpopup(state, data) {
      state.currentpopup = data;
    },
    setqueryflowdata(state, data) {
      state.queryflowdata = data;
    },
    setcheckOpen(state, data) {
      state.checkOpen = data;
    },
    setcheckLink(state, data) {
      state.checkLink = data;
    },
  },
  actions: {
    setcurrentPage(data) {
      console.log(data);
      data.commit("setcurrentPage");
    },
    setcurrentpopup(data) {
      console.log(data);
      data.commit("setcurrentpopup");
    },
    setqueryflowdata(query) {
      query.commit("setqueryflowdata");
    },
    setcheckOpen(check) {
      check.commit("setcheckOpen");
    },
    setcheckLink(check) {
      check.commit("setcheckLink");
    },
  },
};
